import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bim-equipment-detail',
  templateUrl: './bim-equipment-detail.component.html',
  styleUrls: ['./bim-equipment-detail.component.less']
})
export class BimEquipmentDetailComponent implements OnInit {

  constructor() { }

  @Input() currentEquipment: any;

  ngOnInit(): void {
    const myBimDiv = document.getElementById('bim-equipment-table') as HTMLDivElement;
    myBimDiv.innerHTML =  this.showProperties(this.currentEquipment.epName, this.currentEquipment);
  }

  showProperties(name: any, data: any): string {
    let html = null;
    if (html == null) {
      // tslint:disable-next-line: max-line-length
      html = '<div style="height:580px;width:480px;overflow-y:auto;">';
      html += '<table border="1">';
      html += '<tr><th style="height:30px;width:150px">属性名</th><th style="height:30px;width:330px">属性值</th></tr>';
    }
    html += '<tr><td>' + '设备名称' + '</td><td>' + this.isEmpty(name) + '</td></tr>';
    html += '<tr><td>' + '设备编号' + '</td><td>' + this.isEmpty(data.epNo) + '</td></tr>';
    html += '<tr><td>' + '设备级别' + '</td><td>' + this.isEmpty(data.assetLevel) + '</td></tr>';
    html += '<tr><td>' + '设备类型' + '</td><td>' + this.isEmpty(data.assetTypeName) + '</td></tr>';
    html += '<tr><td>' + '设备子类型' + '</td><td>' + this.isEmpty(data.subAssetType) + '</td></tr>';
    html += '<tr><td>' + '购买数量' + '</td><td>' + this.isEmpty(data.purchaseAmount) + '</td></tr>';
    html += '<tr><td>' + '使用人' + '</td><td>' + this.isEmpty(data.usePerson) + '</td></tr>';
    html += '<tr><td>' + '存放位置' + '</td><td>' + this.isEmpty(data.storeLocation) + '</td></tr>';
    html += '<tr><td>' + '使用部门' + '</td><td>' + this.isEmpty(data.useDepartmentName) + '</td></tr>';
    html += '<tr><td>' + '使用公司' + '</td><td>' + this.isEmpty(data.useCompanyName) + '</td></tr>';
    html += '<tr><td>' + '上次维保时间' + '</td><td>' + this.isEmpty(data.lastRepairDate) + '</td></tr>';
    html += '<tr><td>' + '下次维保时间' + '</td><td>' + this.isEmpty(data.nextRepairDate) + '</td></tr>';
    html += '<tr><td>' + '维保周期' + '</td><td>' + this.isEmpty(data.repairPeriod) + '个月</td></tr>';
    html += '<tr><td>' + '保修时间' + '</td><td>' + this.isEmpty(data.repairLimited) + '个月</td></tr>';
    html += '<tr><td>' + '使用寿命' + '</td><td>' + this.isEmpty(data.usefulLife) + '个月</td></tr>';
    html += '<tr><td>' + '设备型号' + '</td><td>' + this.isEmpty(data.equipmentType) + '</td></tr>';
    html += '<tr><td>' + '产地' + '</td><td>' + this.isEmpty(data.purchaseCountry) + '</td></tr>';
    html += '<tr><td>' + '供应商' + '</td><td>' + this.isEmpty(data.purchaseFactory) + '</td></tr>';
    html += '<tr><td>' + '条形码' + '</td><td>' + this.isEmpty(data.barCode) + '</td></tr>';
    html += '<tr><td>' + 'SN' + '</td><td>' + this.isEmpty(data.sn) + '</td></tr>';
    html += '<tr><td>' + '功率' + '</td><td>' + this.isEmpty(data.power) + 'kw</td></tr>';
    html += '<tr><td>' + '电压类型' + '</td><td>' + this.isEmpty(data.voltageType) + '</td></tr>';
    html += '<tr><td>' + '备注' + '</td><td>' + this.isEmpty(data.epRemark) + '</td></tr>';
    html += '</table>';
    html += '</div>';
    return html;
  }

  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return '';
    } else {
      return obj;
    }
  }

}
